var _path, _path2, _path3, _path4, _rect, _g, _path5, _g2, _path6, _path7, _path8, _path9, _path10, _rect2, _g3, _path11, _path12, _path13, _path14, _path15, _rect3, _g4, _path16, _path17, _path18, _path19, _path20, _rect4, _g5, _path21, _path22, _path23, _path24, _path25, _rect5, _g6, _g7, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g8, _g9, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _g10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiquidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 348,
    height: 255,
    viewBox: "0 0 348 255",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.066 120.867L215.093 144.554L174.066 168.241L133.039 144.554L174.066 120.867Z",
    fill: "#801212"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.093 94.6869L174.066 71V120.867L215.093 144.554V94.6869Z",
    fill: "#801212"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M174.066 71L133.039 94.6869V144.554L174.066 120.867V71Z",
    fill: "#801212"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M174.066 118.374L215.093 94.6875V144.555L174.066 168.242V118.374Z",
    fill: "url(#paint0_linear_38_6657)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.3738,
    height: 47.3738,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 174.066 71)",
    fill: "url(#paint1_linear_38_6657)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bdi_38_6657)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.3738,
    height: 47.3738,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 174.066 71)",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 46.3738,
    height: 46.3738,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 174.499 71.25)",
    stroke: "white",
    strokeOpacity: 0.3,
    shapeRendering: "crispEdges"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.039 94.6875L174.066 118.374V168.242L133.039 144.555V94.6875Z",
    fill: "url(#paint2_linear_38_6657)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_38_6657)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 174,
    cy: 127.5,
    rx: 74,
    ry: 27.5,
    fill: "#DBFF00"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.001 121.611L214.226 144.682L174.001 167.752L133.775 144.682L174.001 121.611Z",
    fill: "#801212"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M214.225 95.1627L174 71.9219V120.85L214.225 144.091V95.1627Z",
    fill: "#801212"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.001 71.9219L133.775 95.1627V144.091L174.001 120.85V71.9219Z",
    fill: "#801212"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174 118.825L214.225 95.584V144.512L174 167.753V118.825Z",
    fill: "url(#paint3_linear_38_6657)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M133.775 95.584L174.001 118.825V167.753L133.775 144.512V95.584Z",
    fill: "url(#paint4_linear_38_6657)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 45.2955,
    height: 45.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 174.566 72.5742)",
    fill: "url(#paint5_linear_38_6657)",
    stroke: "url(#paint6_linear_38_6657)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bdf_38_6657)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2955,
    height: 46.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 174.133 72.3242)",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M130.225 145.271L170.451 168.342L130.225 191.412L90 168.342L130.225 145.271Z",
    fill: "#801212"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M170.45 118.823L130.225 95.582V144.51L170.45 167.751V118.823Z",
    fill: "#801212"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M130.225 95.582L90 118.823V167.751L130.225 144.51V95.582Z",
    fill: "#801212"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.225 142.485L170.45 119.244V168.172L130.225 191.413V142.485Z",
    fill: "url(#paint7_linear_38_6657)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119.244L130.225 142.485V191.413L90 168.172V119.244Z",
    fill: "url(#paint8_linear_38_6657)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 45.2955,
    height: 45.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 130.79 96.2344)",
    fill: "url(#paint9_linear_38_6657)",
    stroke: "url(#paint10_linear_38_6657)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_bdf_38_6657)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2955,
    height: 46.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 130.357 95.9844)",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M217.774 145.271L258 168.342L217.774 191.412L177.549 168.342L217.774 145.271Z",
    fill: "#801212"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M257.999 118.823L217.773 95.582V144.51L257.999 167.751V118.823Z",
    fill: "#801212"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M217.774 95.582L177.549 118.823V167.751L217.774 144.51V95.582Z",
    fill: "#801212"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.773 142.485L257.999 119.244V168.172L217.773 191.413V142.485Z",
    fill: "url(#paint11_linear_38_6657)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M177.549 119.244L217.774 142.485V191.413L177.549 168.172V119.244Z",
    fill: "url(#paint12_linear_38_6657)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 45.2955,
    height: 45.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 218.339 96.2344)",
    fill: "url(#paint13_linear_38_6657)",
    stroke: "url(#paint14_linear_38_6657)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_bdf_38_6657)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2955,
    height: 46.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 217.906 95.9844)",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M174.001 168.936L214.226 192.006L174.001 215.076L133.775 192.006L174.001 168.936Z",
    fill: "#801212"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M214.225 142.487L174 119.246V168.174L214.225 191.415V142.487Z",
    fill: "#801212"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M174.001 119.246L133.775 142.487V191.415L174.001 168.174V119.246Z",
    fill: "#801212"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M174 166.149L214.225 142.908V191.836L174 215.077V166.149Z",
    fill: "url(#paint15_linear_38_6657)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M133.775 142.908L174.001 166.149V215.077L133.775 191.836V142.908Z",
    fill: "url(#paint16_linear_38_6657)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 45.2955,
    height: 45.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 174.566 119.898)",
    fill: "url(#paint17_linear_38_6657)",
    stroke: "url(#paint18_linear_38_6657)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_bdf_38_6657)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2955,
    height: 46.2955,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 174.133 119.648)",
    fill: "white",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter6_d_38_6657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.86 113.484C195.86 113.484 195.86 105.651 195.86 101.082C195.86 100.307 195.86 99.6268 195.86 110.275C195.86 98.3327 195.86 97.8732 195.86 97.8732L168.821 97.8732L177.953 103.145L148.424 120.194L156.725 124.987L186.254 107.938L195.86 113.484Z",
    fill: "#DFA101"
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M168.648 92.8732L168.529 92.8047L168.704 97.8047L168.822 97.8732L168.648 92.8732Z",
    fill: "#DFA101"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M195.687 92.875H168.648L168.823 97.875L195.861 97.875L195.687 92.875Z",
    fill: "#DFA101"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M168.648 92.875L177.78 98.1472L177.955 103.147L168.823 97.875L168.648 92.875Z",
    fill: "#DFA101"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M195.686 105.277V92.875L195.86 97.875V110.277L195.686 105.277Z",
    fill: "#DFA101"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M195.686 96.0831V105.276L195.86 110.276V101.083L195.686 96.0831Z",
    fill: "#DFA101"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M195.686 108.484V96.082L195.86 101.082V113.484L195.686 108.484Z",
    fill: "#DFA101"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M177.779 98.1465L148.25 115.195L148.425 120.195L177.954 103.146L177.779 98.1465Z",
    fill: "#DFA101"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M186.08 102.938L195.686 108.483L195.86 113.483L186.255 107.938L186.08 102.938Z",
    fill: "#DFA101"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M156.551 119.986L186.08 102.938L186.255 107.938L156.725 124.986L156.551 119.986Z",
    fill: "#DFA101"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M148.25 115.195L156.551 119.988L156.726 124.988L148.425 120.195L148.25 115.195Z",
    fill: "#DFA101"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter7_bdf_38_6657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M195.687 108.485L195.687 92.8738L168.648 92.8738L177.78 98.146L148.251 115.195L156.552 119.987L186.081 102.939L195.687 108.485Z",
    fill: "#DFA101"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter8_d_38_6657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152.14 125.045C152.14 125.045 152.14 132.879 152.14 137.447C152.14 138.222 152.14 138.902 152.14 128.254C152.14 140.197 152.14 140.656 152.14 140.656L179.179 140.656L170.047 135.384L199.576 118.335L191.275 113.542L161.746 130.591L152.14 125.045Z",
    fill: "#FFE39B"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M179.352 145.656L179.471 145.725L179.296 140.725L179.178 140.656L179.352 145.656Z",
    fill: "#FFE39B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M152.313 145.656L179.352 145.656L179.177 140.656L152.139 140.656L152.313 145.656Z",
    fill: "#FFE39B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M179.352 145.656L170.22 140.384L170.045 135.384L179.177 140.656L179.352 145.656Z",
    fill: "#FFE39B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M152.314 133.254L152.314 145.656L152.14 140.656L152.14 128.254L152.314 133.254Z",
    fill: "#FFE39B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M152.314 142.448L152.314 133.255L152.14 128.255L152.14 137.448L152.314 142.448Z",
    fill: "#FFE39B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M152.314 130.047L152.314 142.449L152.14 137.449L152.14 125.047L152.314 130.047Z",
    fill: "#FFE39B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M170.221 140.385L199.75 123.336L199.575 118.336L170.046 135.385L170.221 140.385Z",
    fill: "#FFE39B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M161.92 135.592L152.314 130.046L152.14 125.046L161.745 130.592L161.92 135.592Z",
    fill: "#FFE39B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M191.449 118.543L161.92 135.592L161.745 130.592L191.275 113.543L191.449 118.543Z",
    fill: "#FFE39B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M199.75 123.336L191.449 118.543L191.274 113.543L199.575 118.336L199.75 123.336Z",
    fill: "#FFE39B"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9,
    filter: "url(#filter9_bdf_38_6657)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.313 130.047L152.313 145.657L179.352 145.657L170.22 140.385L199.749 123.337L191.448 118.544L161.919 135.592L152.313 130.047Z",
    fill: "#FFE39B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bdi_38_6657",
    x: 129.039,
    y: 67,
    width: 90.0547,
    height: 59.373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_38_6657"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_38_6657",
    result: "effect2_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_38_6657",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.956863 0 0 0 0 0.364706 0 0 0 0 0.826588 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect3_innerShadow_38_6657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_38_6657",
    x: 0,
    y: 0,
    width: 348,
    height: 255,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_38_6657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bdf_38_6657",
    x: 130.039,
    y: 68.3242,
    width: 88.1875,
    height: 58.2949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_38_6657"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_38_6657",
    result: "effect2_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_38_6657",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect3_foregroundBlur_38_6657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_bdf_38_6657",
    x: 86.2637,
    y: 91.9844,
    width: 88.1875,
    height: 58.2949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_38_6657"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_38_6657",
    result: "effect2_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_38_6657",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect3_foregroundBlur_38_6657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_bdf_38_6657",
    x: 173.812,
    y: 91.9844,
    width: 88.1875,
    height: 58.2949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_38_6657"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_38_6657",
    result: "effect2_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_38_6657",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect3_foregroundBlur_38_6657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_bdf_38_6657",
    x: 130.039,
    y: 115.648,
    width: 88.1875,
    height: 58.2949,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_38_6657"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_38_6657",
    result: "effect2_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_38_6657",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect3_foregroundBlur_38_6657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_38_6657",
    x: 144.424,
    y: 97.873,
    width: 55.4355,
    height: 35.1133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.432622 0 0 0 0 0.0022226 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_6657",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_bdf_38_6657",
    x: 128.25,
    y: 72.873,
    width: 87.4375,
    height: 67.1152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_38_6657"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_38_6657",
    result: "effect2_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_38_6657",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect3_foregroundBlur_38_6657"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_38_6657",
    x: 148.141,
    y: 113.543,
    width: 55.4355,
    height: 35.1133,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.432622 0 0 0 0 0.0022226 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_38_6657",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_bdf_38_6657",
    x: 132.312,
    y: 98.543,
    width: 87.4375,
    height: 67.1152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_38_6657"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_38_6657",
    result: "effect2_dropShadow_38_6657"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_38_6657",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect3_foregroundBlur_38_6657"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_38_6657",
    x1: 169,
    y1: 113.5,
    x2: 194.58,
    y2: 168.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_38_6657",
    x1: 23.6869,
    y1: 0,
    x2: 23.6869,
    y2: 47.3738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_38_6657",
    x1: 153.553,
    y1: 94.6875,
    x2: 153.553,
    y2: 168.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84AF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.415,
    stopColor: "#E478EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E190EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA7E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_38_6657",
    x1: 165.49,
    y1: 73.5175,
    x2: 278.887,
    y2: 135.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_38_6657",
    x1: 125.265,
    y1: 73.5175,
    x2: 238.663,
    y2: 135.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_38_6657",
    x1: -9.79464,
    y1: -14.1554,
    x2: 76.3512,
    y2: 70.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_38_6657",
    x1: 23.1477,
    y1: 0,
    x2: 23.1477,
    y2: 46.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_38_6657",
    x1: 121.714,
    y1: 97.1776,
    x2: 235.112,
    y2: 159.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_38_6657",
    x1: 81.4896,
    y1: 97.1776,
    x2: 194.887,
    y2: 159.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_38_6657",
    x1: -9.79464,
    y1: -14.1554,
    x2: 76.3512,
    y2: 70.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_38_6657",
    x1: 23.1477,
    y1: 0,
    x2: 23.1477,
    y2: 46.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_38_6657",
    x1: 209.263,
    y1: 97.1776,
    x2: 322.661,
    y2: 159.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_38_6657",
    x1: 169.038,
    y1: 97.1776,
    x2: 282.436,
    y2: 159.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_38_6657",
    x1: -9.79464,
    y1: -14.1554,
    x2: 76.3512,
    y2: 70.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_38_6657",
    x1: 23.1477,
    y1: 0,
    x2: 23.1477,
    y2: 46.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_38_6657",
    x1: 165.49,
    y1: 120.842,
    x2: 278.887,
    y2: 183.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_38_6657",
    x1: 125.265,
    y1: 120.842,
    x2: 238.663,
    y2: 183.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_38_6657",
    x1: -9.79464,
    y1: -14.1554,
    x2: 76.3512,
    y2: 70.8145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B98501"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#DFA101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#996E01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_38_6657",
    x1: 23.1477,
    y1: 0,
    x2: 23.1477,
    y2: 46.2955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidity);
export default __webpack_public_path__ + "static/media/liquidity.5b223f0c1672e3257003883453773a86.svg";
export { ForwardRef as ReactComponent };